/* eslint-disable no-param-reassign */
import { useRouter } from "next/router"
import { useEffect } from "react"
import { useWindowSize } from "rooks"
import Link from "@components/anti/Link"
import { Image } from "@components/anti/Image"
import { translations } from "src/helper/translations"

function InvestorsPdfItem({ className, title, date, linkPdf }) {
  const router = useRouter()
  const { innerWidth } = useWindowSize()
  const { locale } = router
  const changeHeight = () => {
    if (innerWidth > 992) {
      setTimeout(() => {
        const arr = []
        document
          .querySelectorAll(".investors-pdf-item")
          .forEach((el) => arr.push(el.clientHeight))
        document.querySelectorAll(".investors-pdf-item").forEach((el) => {
          el.style.minHeight = `${Math.max(...arr)}px`
        })
      }, 100)
    } else {
      setTimeout(() => {
        document.querySelectorAll(".investors-pdf-item").forEach((el) => {
          el.style.height = "fit-content"
        })
      }, 100)
    }
  }

  useEffect(() => {
    // notes from adil: remove dependecy so it won't decreasing its height
    // if (innerWidth > 992) {
    //   changeHeight()
    window.addEventListener("resize", changeHeight)
    return () => {
      window.removeEventListener("resize", changeHeight)
    }
    // }
  }, [])
  return (
    <div className={`investors-pdf-item ${className}`} role="presentation">
      <div className="row row-3 w-100 h-100">
        <div className="col-2 col-img">
          <Image
            src="/img/icon/img_icon-pdf.png"
            width={64}
            height={64}
            alt="pdf-icon"
            className="investors-pdf-item__icon"
          />
        </div>
        <div className="col-10 col-text">
          <Link href={linkPdf} target="_blank">
            <h6 className="investors-pdf-item__title">{title}</h6>
          </Link>
          <p className="investors-pdf-item__date">{date}</p>
          <div className="row-btn d-flex">
            <Link
              href={linkPdf}
              target="_blank"
              className="investors-pdf-item__view-btn mr-3"
              withArrow
            >
              {translations[`view_${locale}`]}
            </Link>
            <Link
              href={`/api/download?url=${linkPdf}&title=${title}`}
              download
              className="investors-pdf-item__download-btn"
              withArrow
              target="_blank"
            >
              {translations[`download_${locale}`]}
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InvestorsPdfItem
